import styled from 'styled-components';
import * as colors from '~/config/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 55rem;

  @media (max-width: 768px) {
    width: 100%;
  }

  .Container__info {        
    /* padding: 10px 10px;
    margin: 0.5em 0.5em;
    border-radius: 3px;
    border: 0.1em solid; */
    /*  */
    input {
        height: 1rem;  
        background: ${colors.CAMPO_INFORMACAO};        
    }
  }

  .Container__liberacao {        
    /* padding: 10px 10px;
    margin: 0.5em 0.5em;
    border-radius: 3px;
    border: 0.1em solid; */
    /*  */
    input {
        height: 1rem;  
        font-size: 2rem;       
        color : black;
        font-weight: 900;
        letter-spacing: 1px;
        font-family:  'verdana, sans-serif';
        text-align: center;
        background: ${colors.CAMPO_INFORMACAO};       
    }
  }

  /* > .MuiFormControl-root {
    margin-bottom: 2rem;
  }

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0 !important;
  } */
`;

